import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Ticket,
  TicketComment,
  TicketAttachment,
  TicketCategory,
  TicketStatus,
  AttachmentUploadData,
  GetTicketsRequest,
  CreateTicketRequest,
  UpdateTicketRequest
} from '@models/ticket-data.model';

export const IssueTrackerActions = createActionGroup({
  source: 'Issue Tracker',
  events: {

    'Get Tickets': props<{ request: GetTicketsRequest }>(),
    'Get Tickets Success': props<{ tickets: Ticket[] }>(),
    'Get Tickets Failure': props<{ error: string }>(),

    'Create Ticket': props<{ ticket: CreateTicketRequest; attachmentData?: AttachmentUploadData[]; isPhi: boolean }>(),
    'Create Ticket Success': props<{ ticket: Ticket; attachmentData?: AttachmentUploadData[]; isPhi: boolean }>(),
    'Create Ticket Failure': props<{ error: string }>(),

    'Update Ticket': props<{ ticketId: number; updates: UpdateTicketRequest }>(),
    'Update Ticket Success': props<{ ticket: Ticket }>(),
    'Update Ticket Failure': props<{ error: string }>(),

    'Add Ticket Comment': props<{ ticketId: number; comment: string }>(),
    'Add Ticket Comment Success': props<{ comment: TicketComment }>(),
    'Add Ticket Comment Failure': props<{ error: string }>(),

    'Delete Ticket Comment': props<{ commentId: number }>(),
    'Delete Ticket Comment Success': props<{ commentId: number }>(),
    'Delete Ticket Comment Failure': props<{ error: string }>(),

    'Upload Ticket Attachment': props<{ ticketId: number; file: File; isPhi: boolean; dataEnrichmentDocumentType: string; dataEnrichmentDocumentDate: string }>(),
    'Upload Ticket Attachment Success': props<{ attachment: TicketAttachment }>(),
    'Upload Ticket Attachment Failure': props<{ error: string }>(),

    'Update Ticket Attachment': props<{ attachmentId: number; dataEnrichmentDocumentType: string; dataEnrichmentDocumentDate: string }>(),
    'Update Ticket Attachment Success': props<{ attachment: TicketAttachment }>(),
    'Update Ticket Attachment Failure': props<{ error: string }>(),

    'Delete Ticket Attachment': props<{ attachmentId: number }>(),
    'Delete Ticket Attachment Success': props<{ attachmentId: number }>(),
    'Delete Ticket Attachment Failure': props<{ error: string }>(),

    'Download Attachment': props<{ attachmentId: number; fileName: string }>(),
    'Download Attachment Success': props<{ blob: Blob; fileName: string }>(),
    'Download Attachment Failure': props<{ error: string }>(),

    'Preview Attachment': props<{ attachmentId: number; fileName: string }>(),
    'Preview Attachment Success': props<{ blob: Blob; fileName: string }>(),
    'Preview Attachment Failure': props<{ error: string }>(),

    'Get Ticket Categories': emptyProps(),
    'Get Ticket Categories Success': props<{ categories: TicketCategory[] }>(),
    'Get Ticket Categories Failure': props<{ error: string }>(),

    'Get Ticket Statuses': emptyProps(),
    'Get Ticket Statuses Success': props<{ statuses: TicketStatus[] }>(),
    'Get Ticket Statuses Failure': props<{ error: string }>(),

    'Populate Comment Data': props<{ comment: TicketComment }>(),
    'Populate Attachment Data': props<{ attachment: TicketAttachment }>(),
  }
});
